export default {
    //Splash
    splash_message: 'منصة الاتصال والتدريب',

    //TTCC
    accept_ttcc: 'قبول الشروط والأحكام',

    //Login
    welcome: 'مرحبًا!',
    welcome_message: 'dots، حليفك التكنولوجي الجديد في الاتصال والتدريب.',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    code: 'الرمز',
    recover_password: 'استعادة كلمة المرور',
    log_in: 'تسجيل الدخول',
    log_in_biometrics: 'تسجيل الدخول باستخدام البيانات البيومترية',
    create_user: 'إنشاء مستخدم',
    recover_access_to_account: 'أدخل اسم المستخدم لاستعادة الوصول إلى حسابك',
    back: 'العودة',
    enter_new_password: 'أدخل الرمز وكلمة المرور الجديدة',
    enter_code: 'أدخل الرمز',
    new_password: 'كلمة المرور الجديدة',
    repeat_new_password: 'تكرار كلمة المرور الجديدة',
    validate: 'تحقق',
    complete_all_fields: 'أكمل جميع الحقول',
    passwords_do_not_match: 'كلمات المرور غير متطابقة',
    user_created_successfully: 'تم إنشاء المستخدم بنجاح',
    create_user: 'إنشاء مستخدم',
    required_fields: 'الحقول المطلوبة',
    confirm_your_email: 'تأكيد بريدك الإلكتروني',
    confirm_your_phone: 'أكد هاتفك',
    confirm_password: 'تأكيد كلمة المرور',
    modifying_email: 'أنت تقوم بتعديل بريدك الإلكتروني',
    validate_code: 'تحقق من الرمز',
    code_sent_successfully: 'تم إرسال الرمز بنجاح',
    password_reset: 'تمت إعادة تعيين كلمة المرور بنجاح',
    enter_confirmation_code: 'أدخل رمز التأكيد الخاص بك',
    enter_your_new_email: 'أدخل بريدك الإلكتروني الجديد',
    //nuevos al 01-08-2024
    user_does_not_exist: 'عذرًا! لم نعثر على حسابك',
    contact_the_administrator: 'يبدو أن المستخدم الذي أدخلته غير موجود.\nتحقق من كتابته بشكل صحيح\nأو تواصل مع المدير.',
    invalid_user_or_pass: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    info_is_not_correct: 'بعض المعلومات غير صحيحة، يرجى المحاولة مرة أخرى.',
    enter_user: 'يرجى إدخال اسم المستخدم',
    nonexistent_user: 'المستخدم غير موجود. يرجى المحاولة مرة أخرى.',
    incorrect_code: 'الرمز غير صحيح',
    change_saved_successfully: 'تم حفظ التغيير بنجاح',
    pass_changed_successfully: 'تم تغيير كلمة المرور بنجاح',
    check_your_email: 'تحقق من بريدك الإلكتروني للحصول على رمز التحقق',
    eight_characters: '*يجب أن تحتوي على أكثر من 8 أحرف',
    one_uppercase_letter: '*يجب أن تحتوي على حرف واحد كبير على الأقل',
    one_special_character: '*يجب أن تحتوي على حرف خاص واحد على الأقل (@,$,!,#,?)',
    pass_requirements:
        'يجب أن تستوفي المتطلبات التالية:\n\n*يجب أن تحتوي على أكثر من 8 أحرف\n*يجب أن تحتوي على حرف واحد كبير على الأقل\n*يجب أن تحتوي على حرف خاص واحد على الأقل (مثل: $, !, #, ?)',
    select_date: 'يرجى اختيار تاريخ',
    cannot_create_password: 'لا يمكن إنشاء كلمة المرور',
    complete_your_details: 'يرجى إكمال بياناتك للمتابعة',
    validate_code: 'تحقق من الرمز',
    enter_valid_number: 'يجب إدخال رقم صحيح',
    complete_numbers:
        'يجب حذف البادئة "15" ليصبح الرقم النهائي مكونًا من 13 رقمًا، على سبيل المثال: +54 9 XXX XXX XXXX، يجب إكمال الـ 10 أرقام المتبقية.',

    //Profile
    insufficient_permissions: 'صلاحيات غير كافية',
    permissions_are_required: 'الصلاحيات مطلوبة للوصول إلى الكاميرا ومعرض الصور.',
    choose_font: 'اختيار المصدر',
    where_do_you_want: 'من أين ترغب في اختيار الصورة؟',
    camera: 'الكاميرا',
    gallery: 'المعرض',
    edit_photo: 'تحرير الصورة',
    cancel: 'إلغاء',
    save: 'حفظ',
    app: 'التطبيق',
    support: 'الدعم',
    other: 'آخر',
    contact_channel: 'قناة الاتصال',
    select_the_contact_channel: 'حدد قناة الاتصال',
    subject: 'الموضوع',
    write_the_subject: 'اكتب الموضوع',
    message: 'الرسالة',
    write_a_comment: 'اكتب تعليقًا',
    send: 'إرسال',
    sent_successfully: 'تم الإرسال بنجاح',
    thank_you_for_leaving_us_your_comments: 'شكرًا لك على ترك تعليقاتك، سيتم التواصل معك قريبًا.',
    close: 'إغلاق',
    check_for_update: 'التحقق من التحديث',
    clear_cache: 'مسح ذاكرة التخزين المؤقت',
    delete_account: 'حذف الحساب',
    log_out: 'تسجيل الخروج',
    notifications: 'الإشعارات',
    insufficient_permissions: 'صلاحيات غير كافية',
    permissions_to_access: 'الصلاحيات مطلوبة للوصول إلى الكاميرا ومعرض الصور.',
    choose_font: 'اختيار المصدر',
    select_the_image: 'من أين ترغب في اختيار الصورة؟',
    change_language: 'تغيير اللغة',
    change_language_title: 'مهم!',
    change_language_message:
        'لتنفيذ هذا الإجراء، فمن الضروري أن يكون لديك اتصال بالإنترنت. سيؤدي هذا إلى حذف المحتوى الذي تم تنزيله للاستخدام دون اتصال بالإنترنت. يرجى ملاحظة أن التغيير سيؤثر فقط على محتوى التطبيق وليس على بنيته، والتي تعتمد على لغة جهازك.',
    logout_not_available: 'تسجيل الخروج غير متاح',
    cant_logout: 'لا يمكنك تسجيل الخروج في الوقت الحالي لأنك غير متصل بالإنترنت. يرجى التحقق من الاتصال الخاص بك والمحاولة مرة أخرى.',
    //nuevos al 01-08-2024
    cache_cleared: 'تم مسح ذاكرة التخزين المؤقت بنجاح',
    deletes_the_content: 'يؤدي هذا الإجراء إلى حذف المحتوى الذي تم تنزيله لاستخدام التطبيق في وضع عدم الاتصال. تأكد من أنك متصل لمواصلة التصفح.',
    error_uploading_image: 'خطأ في تحميل الصورة: ',
    there_was_an_error: 'حدث خطأ أثناء تحميل الصورة. يرجى المحاولة مرة أخرى.',
    //nuevos al 21-11-2024
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    name: 'الاسم',
    last_name: 'اللقب',
    role: 'الدور',
    verify: 'التحقق',
    verified: 'تم التحقق',
    contact_channels: 'قنوات الاتصال',
    editing_your_email: 'أنت تقوم بتحرير بريدك الإلكتروني',
    editing_your_phone: 'أنت تقوم بتحرير رقم هاتفك',
    modifying_your_email:
        'أنت تقوم بتعديل بريدك الإلكتروني، ستتلقى رمزًا عبر بريدك الإلكتروني لإدخاله. إذا لم تستلم الرمز بعد، يرجى التحقق منه مرة أخرى.',
    modifying_your_phone:
        'أنت تقوم بتعديل رقم هاتفك المحمول، ستتلقى رمزًا عبر الرسائل القصيرة (SMS) لإدخاله. إذا لم تستلم الرمز بعد، يرجى التحقق منه مرة أخرى.',

    //Notifications
    all: 'الكل',
    unread: 'غير مقروء',
    read: 'مقروء',
    seen: 'مُشاهد',
    notifications: 'الإشعارات',
    here_you_will_find: 'هنا ستجد جميع التنبيهات والإشعارات!',
    mark_all_read: 'وضع علامة على الكل كمقروء',
    you_have_no_notifications: 'ليس لديك أي إشعارات!',
    you_will_soon_start: 'ستبدأ قريبًا في استقبال الاتصالات الجديدة',

    //Buscador
    enter_your_search: 'أدخل بحثك',
    no_results: 'لا توجد نتائج',
    search_content: 'ابحث عن المحتوى الذي يهمك.',
    see: 'رؤية',
    results_in: 'النتائج في',
    see_less_results: 'عرض أقل من النتائج',
    all: 'الكل',
    wall: 'الجدار',
    learning: 'التعلم',
    benefits: 'الفوائد',
    portfolio: 'المحفظة',
    retry: 'إعادة المحاولة',
    locked: 'مغلق',
    pending: 'قيد الانتظار',
    seen: 'مُشاهد',
    approved: 'تمت الموافقة عليه',

    //Posts
    see_them: 'مشاهدة الكل ',
    _comments: ' تعليقات',
    reactions_from_other_users: 'تفاعلات من مستخدمين آخرين',
    not_connected_to_the_network: 'أنت غير متصل بالشبكة',
    comment: 'تعليق',
    comments: 'تعليقات',
    write_a_comment: 'اكتب تعليقًا',
    no_content: 'لا يوجد محتوى',
    not_connected_to_the_network: 'أنت غير متصل بالشبكة',
    reaction: 'رد فعل',
    reactions: 'تفاعلات',
    first_comment: 'كن أول من يترك تعليقًا!',
    no_comment: 'لا توجد تعليقات على هذه المشاركة حتى الآن.',
    write_a_comment: 'اكتب تعليقًا',
    no_publications: 'لا توجد منشورات',
    no_post_to_read: 'ليس لديك منشورات للقراءة.',
    views: 'مشاهدات',
    reply: 'الرد',
    see: 'رؤية ',
    more_answers: 'إجابات أخرى',
    hide: 'إخفاء ',
    answers: ' إجابات',
    no_reactions: 'لا توجد ردود فعل بعد!',
    leave_your_reaction: 'كن أول من يترك رد فعلك.',
    //nuevos al 01-08-2024
    full_survey: 'لقد أكملت الاستطلاع!',
    thanks_for_participating: 'شكرا للمشاركة! راقب الحائط لمزيد من التحديثات.',
    sent_automatically: 'سيتم إرساله تلقائياً عندما تعود للاتصال.',
    no_post_saved: 'لا توجد منشورات محفوظة حتى الآن',
    see_your_favorite_content: 'سترى هنا المحتوى المفضل لديك.',
    //fechas
    instant: 'قبل لحظات قليلة',
    hourFirst: 'منذ ',
    hour: ' ساعة',
    hours: ' ساعات',
    day: ' يوم',
    days: ' أيام',

    //Learning
    congratulations: 'تهانينا!',
    you_approved: 'لقد اجتزت بـ ',
    you_completed: 'لقد أكملت هذا الدورة',
    you_disapproved: 'تقييم رفض',
    score: 'النتيجة:',
    return_to_course: 'العودة إلى الصفحة الرئيسية',
    retry: 'إعادة المحاولة',
    it_is_available: 'متاح الآن',
    total_course_evaluation: 'تقييم الدورة الكامل',
    evaluate_me: 'قيمني',
    completed_the_course: 'لقد أكملت الدورة',
    pending_approval: 'بانتظار الموافقة',
    return: 'العودة',
    continue_course: 'متابعة الدورة',
    you_have_made: 'لقد أكملت ',
    of_the_course: ' من الدورة',
    locked: 'مغلق',
    pending: 'قيد الانتظار',
    seen: 'مُشاهد',
    complete: 'اكتمل',
    reprobate: 'فشل',
    sync_pend: 'مزامنة معلقة',
    in_progress: 'قيد التقدم',
    perform_evaluation: 'أداء التقييم',
    next_content: 'المحتوى التالي',
    you_completed_all: 'لقد أكملت جميع المحتويات',
    final_evaluation: 'التقييم النهائي',
    retry_mayus: 'إعادة المحاولة',
    see_more: '...المزيد',
    see_less: '...أقل',
    back_to_course: 'العودة إلى الدورة',
    click_to_see: 'انقر لرؤية',
    //Evaluaciones
    evaluation: 'التقييم: ',
    of: ' من ',
    loading_evaluation: 'جارٍ تحميل التقييم...',
    select_option: 'يجب عليك تحديد خيار للمتابعة',
    select_one_answer: 'يرجى اختيار إجابة واحدة على الأقل لكل سؤال.',
    exit_evaluation: 'هل ترغب في الخروج من التقييم؟',
    your_answers_will_not_be_saved: 'إذا غادرت الآن، فلن يتم حفظ إجاباتك',
    continue_evaluation: 'متابعة التقييم',
    leave_anyway: 'غادر على أي حال',
    try_again: 'حاول مرة أخرى!',
    passed_the_evaluation: 'لقد اجتزت التقييم',
    start_the_course_again: 'لم تحصل على درجة كافية لاجتياز التقييم. ابدأ الدورة مرة أخرى لتتمكن من اجتيازه.',
    evaluation_pending_approval: 'تقييم قيد الموافقة',
    notification_result_evaluation: 'سوف تتلقى قريبًا إشعارًا بنتيجة تقييمك',
    write_here: 'اكتب هنا...',
    close: 'إغلاق',
    confirm: 'تأكيد',
    sync_pending: 'مزامنة معلقة',
    view_certificate: 'عرض الشهادة',
    // nuevos al 27-01-2025
    course_download_in_process: 'جارٍ تنزيل الدورة',
    course_is_downloading: 'يرجى الانتظار لبضع ثوانٍ. الدورة قيد التنزيل حتى تتمكن من الوصول إلى جميع المحتويات دون اتصال دون أي مشاكل.',
    downloaded_course: 'تم تنزيل الدورة بنجاح',
    you_can_train_offline: 'تم! يمكنك الآن التدريب بدون اتصال.',
    delete_offline_course: 'هل تريد حذف التنزيل غير المتصل لهذا الدورة؟',
    not_view_course_offline: 'لن تتمكن من مشاهدة هذه الدورة بدون اتصال.',
    course_is_not_available: 'الدورة لم تعد متوفرة...',
    not_available_offline: 'لم تعد متوفرة بدون اتصال، ولكن يمكنك تنزيلها مرة أخرى عندما تحتاج إليها.',
    content_download_in_process: 'جارٍ تنزيل المحتوى',
    content_is_downloading: 'يرجى الانتظار لبضع ثوانٍ. المحتوى قيد التنزيل حتى تتمكن من الوصول إليه بالكامل بدون اتصال دون أي مشاكل.',
    downloaded_content: 'تم تنزيل المحتوى بنجاح',
    delete_offline_content: 'هل ترغب في حذف المحتوى غير المتصل؟',
    not_view_content_offline: 'عند حذفه، لن تتمكن من الوصول إلى المحتوى بدون اتصال.',
    content_is_not_available: 'المحتوى لم يعد متوفرا...',
    download_offline: 'تنزيل بدون اتصال',
    available_offline: 'متاح بدون اتصال',
    delete: 'يمسح',

    //Stores
    your_progress_in_stores: 'تقدمك في المتاجر',
    map: 'الخريطة',
    daily_survey: 'استطلاع يومي',
    survey: 'استطلاع',
    matutino: 'الصباحي',
    vespertino: 'المسائي',
    form: 'النموذج',
    enter_a_number: 'أدخل رقمًا',
    campaign_expiration: 'انتهاء الحملة: ',
    store_indicators: 'مؤشرات المتجر',
    last_days: 'المتعلقة بالأيام الـ30 الماضية',
    main_indicators: 'اعرف تقدم المؤشرات الرئيسية في المتجر',
    store_information: 'العثور على معلومات المتجر ذات الصلة لتحقيق مستويات متجر مثالية',
    perform_executions: 'أداء التنفيذات التالية لمعرفة حالة المتجر',
    pending_mayus: 'قيد الانتظار',
    approved_mayus: 'موافق عليه',
    in_review_mayus: 'قيد المراجعة',
    redo_mayus: 'إعادة',
    visited_mayus: 'زار',
    visited_mayus_sync: 'زار SYNC',
    visited_store_mayus: 'المتاجر التي تم زيارتها',
    checkin_realized_sync: 'المتاجر التي تم زيارتها SYNC',
    moderation_mayus: 'اعتدال',
    review_mayus: 'مراجعة',
    in_progress_mayus: 'قيد التقدم',
    sync_pend_mayus: 'مزامنة معلقة',
    locked_mayus: 'مغلق',
    complete_mayus: 'مكتمل',
    perfect_store: 'متجر مثالي',
    execution: 'التنفيذ',
    vouchers: 'القسائم',
    send: 'إرسال',
    requires: 'يتطلب ',
    variation: 'التباين',
    validity: 'الصلاحية: ',
    points: 'نقاط',
    voucher_canceled: 'تم إلغاء القسيمة',
    you_can_try_again: 'لا تقلق! يمكنك المحاولة مرة أخرى.',
    voucher_successful: 'تم استرداد القسيمة بنجاح',
    successful_promo: 'تم اكتمال العرض الترويجي بنجاح!',
    voucher_pending: 'القسيمة قيد الانتظار',
    wait_for_the_validation: 'انتظر تحقق قسيمتك',
    your_code_is_being_scanned: 'جارٍ مسح رمزك ⏳',
    view_qr: 'عرض الرمز الاستجابي السريع',
    return_to_store: 'العودة إلى المتجر',
    stores_objective: 'يجب أن تلبي الهدف الخاص بالمتاجر.',
    welcome_stores: 'نرحب بكم في المتاجر!',
    tip_day: 'هنا يمكنك زيارة متاجرك لهذا اليوم، وأداء استطلاعاتك المطلوبة ومراجعة تقدمك.',
    close_mayus: 'إغلاق',
    select_form: 'حدد نموذجًا للبدء',
    select_one_form: 'لبدء الاستطلاع يجب عليك اختيار أحد النماذج.',
    answer_all_questions: 'يجب عليك الإجابة على جميع الأسئلة للمتابعة.',
    schedule_not_found: 'لم يتم العثور على الجدول الزمني لليوم.',
    form_not_found: 'النموذج غير موجود في الجدول الزمني.',
    send: 'إرسال',
    check_in: 'تسجيل الدخول',
    check_out: 'الخروج',
    check_out_done: 'تم تسجيل الخروج',
    off_route: 'أنت بعيد عن المسار، أدخل هنا للعودة إلى الجدول لمدة',
    search_barcode: 'البحث بواسطة الباركود',
    no_agenda_today: 'ليس لديك أي جدول لليوم!',
    no_agenda_week: 'ليس لديك جدول للأسبوع!',
    no_information_today: 'ليس لديك جدول لهذا التاريخ، إذا كان لديك أي أسئلة، يرجى استشارة مشرفك.',
    no_information_week: 'نحن لا نتلقى معلومات لمستخدمك، إذا كانت لديك أي أسئلة يرجى الاتصال بمشرفك.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'ليس لديك أذونات الكاميرا',
    activate_from_settings: 'قم بتمكين ذلك من إعدادات جهازك للمتابعة.',
    modify_permissions: 'تعديل الأذونات',
    complete_fields: 'أكمل الحقول التالية لإنشاء متجر',
    create: 'إنشاء',
    store_name: 'اسم المتجر',
    enter_store_name: 'أدخل اسم المتجر',
    sore_address: 'العنوان',
    enter_sore_address: 'أدخل عنوان المتجر',
    cluster: 'مجموعة',
    store_phone: 'الهاتف',
    enter_sore_phone: 'أدخل هاتف المتجر',
    activate_survey: 'لتفعيل الاستبيان 1.1 Vespertino، يجب عليك إكمال أهداف المتاجر. الأهداف: ',
    inactive_vespertino: 'Vespertino غير نشط',
    active_vespertino: 'Vespertino نشط',
    completed_your_mandatory_objectives: 'لقد أكملت أهدافك الإلزامية لليوم، يمكنك الآن إجراء Vespertino الخاص بك.',
    complete_now: 'أكمل الآن',
    perform_later: 'قم بالقيام لاحقًا',
    back_to_your_agenda: 'هل ترغب في العودة إلى جدول أعمالك اليومي؟',
    return_to_the_current_day: 'أنت تشاهد أنشطة الأيام السابقة، إذا ضغطت على متابعة، ستعود إلى اليوم الحالي: ',
    continue: 'متابعة',
    reached_your_goal: 'لقد حققت هدفك!',
    search_by_barcode: 'ابحث بواسطة رمز الشريط',
    scan_the_barcode: 'امسح رمز الشريط لأي منتج\nفي قائمة هذا الاستبيان.',
    return_to_form: 'العودة إلى النموذج',
    product_not_found: 'المنتج غير موجود',
    code_does_not_match: 'الرمز لا يتطابق مع أي منتج مرتبط بهذا النموذج.',
    search_another_product: 'ابحث عن منتج آخر',
    form_submitted_successfully: 'لقد كان ناجحا!',
    send_new_survey: 'إذا رغبت، يمكنك إرسال استبيان جديد.',
    no_agenda_for_today: 'لا يوجد جدول أعمال لليوم!',
    consult_your_supervisor: 'ليس لديك جدول أعمال لهذا التاريخ، لأي استفسار تواصل مع المشرف.',
    visiting_your_store: 'أنت تزور متجرك ',
    you_can_check_out: 'يمكنك تسجيل الخروج بدون إكمال الاستبيان: ',
    you_met_the_goal: 'لقد حققت الهدف، ليس من الضروري إكمال النموذج.',
    you_must_complete_the_survey: 'لإتمام تسجيل الخروج، يجب عليك إكمال الاستبيان: ',
    checkin_blocked: 'تسجيل الدخول محظور',
    close_the_open_checkin: 'للمتابعة، يجب إغلاق تسجيل الدخول المفتوح.',
    close_the_checkin_opened_in: 'للمتابعة، يجب إغلاق تسجيل الدخول المفتوح في: ',
    checkin_out_of_range: 'تسجيل الدخول خارج النطاق',
    more_meters_from_the_store: 'أنت على بعد أكثر من 150 متر من المتجر.',
    now_is_your_turn: 'الآن دورك!',
    surveys_in_progress: 'لديك استبيانات قيد التقدم: ',
    unfinished_surveys: 'لديك استبيانات غير مكتملة: ',
    want_to_checkout: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    selected_store: 'المتجر المختار',
    checkout_blocked: 'تسجيل الخروج محظور',
    uncompleted_forms: 'لديك نماذج غير مكتملة!',
    checkout_anyway: 'هل تريد تسجيل الخروج على أي حال؟',
    go_to_survey: 'اذهب إلى الاستبيان',
    take_the_survey: 'الآن يمكنك إتمام الاستبيان!',
    validity: 'صلاحية: ',
    search_store: 'بحث في المتجر...',
    no_results_for_your_search: 'لا توجد نتائج لبحثك',
    find_another_store: 'ابحث عن متجر آخر',
    //nuevos al 21-11-2024
    loading: 'جارٍ التحميل...',
    error_getting_data: 'خطأ في الحصول على البيانات.',
    no_information_to_display: 'لا توجد معلومات لعرضها.',
    unzipping: 'جارٍ فك الضغط...',
    saving: 'جارٍ الحفظ',
    loading_stores: 'جارٍ تحميل المتاجر...',
    getting_stores: 'جارٍ الحصول على المتاجر...',
    request_has_failed: 'تم الوصول إلى الحد الأقصى لعدد المحاولات. فشل الطلب.',
    a_few_minutes: 'جارٍ تحميل المتاجر...\nقد يستغرق هذا العملية بضع دقائق.',
    //nuevos al 27-01-2025
    assets_download_completed: 'اكتمل تنزيل الأصول لمتجر Perfect Store',
    perfect_store_download: 'اكتمل تنزيل صورة النجاح لمتجر Perfect Store',
    perfect_store_error: 'خطأ في تنزيل الأصول لمتجر Perfect Store',
    connection_interrupted: 'تم قطع الاتصال، سيتم فك ضغط صورة النجاح عند استعادة الاتصال.',
    decompressing_perfect_store: 'تحميل المتجر المثالي',
    downloading_perfect_store: 'جارٍ تنزيل المتجر المثالي',
    saving_perfect_store: 'جارٍ حفظ المتجر المثالي',
    remain_downloaded: '\nتبقى للتنزيل ',
    assets: ' الأصول.',

    //Portfolio
    no_brands_to_show: 'لا توجد علامات تجارية لعرضها',
    no_products_to_show: 'لا توجد منتجات لعرضها',
    try_again_later: 'حاول مرة أخرى لاحقًا',
    portfolio: 'المحفظة',
    select_one: 'حدد إحدى علاماتنا التجارية لعرض منتجاتها وخدماتها.',
    learn_about: 'تعرف على مجموعة المنتجات والخدمات الكاملة في تطبيقنا.',
    //nuevos al 01-08-2024
    brand: 'ماركة',
    description: 'وصف',
    ingredients: 'مكونات',
    data_sheet: 'ورقة بيانات',

    //Benefits
    points_can_be_exchanged: 'يمكن استبدالها بـ:',
    approved: 'موافق عليه',
    cancelled: 'ألغيت',
    pending: 'قيد الانتظار',
    redeemed: 'تم استردادها',
    added_points: 'تمت إضافة النقاط',
    all: 'الكل',
    my_points: 'نقاطي',
    your_points: 'نقاطك',
    delivered: 'تم التسليم',
    no_benefits: 'لا توجد فوائد بعد',
    add_points: 'كسب النقاط مع تفاعلاتك لاستبدالها',
    no_history: 'لا توجد تاريخ بعد',
    redeem_your_points: 'استبدال نقاطك وسترى تاريخ فوائدك هنا',
    pending_approval: 'بانتظار الموافقة',
    when_it_is_approved: 'عندما يتم الموافقة عليه، ستراه معتمدًا في تاريخ فوائدك',
    unredeemed_benefit: 'فائدة غير مُستردة',
    you_dont_have_enough_points: 'ليس لديك ما يكفي من النقاط لاستبدال هذه الفائدة',
    accept: 'قبول',
    units_available: ' وحدات متاحة',
    redeem_benefit: 'استبدال الفائدة',
    benefits_mayus: 'فَوائد',
    history: 'تاريخ',
    there_was_a_mistake: 'حدث خطأ',

    //Vouchers
    complete_to_redeem_the_voucher: 'اكمل لاسترداد القسيمة',
    valid_until: 'صالح حتى: ',
    quantity_purchased: 'الكمية المشتراة: ',
    redeem: 'استبدال',
    lumps: 'كتل',
    voucher_redeemed: 'تم استرداد القسيمة بنجاح',
    error_redeeming_voucher: 'حدث خطأ أثناء استرداد القسيمة. حاول مرة أخرى.',
    validate_and_redeem_vouchers: 'تحقق واسترداد القسائم',
    to_get_started: 'للبدء، أدخل أو امسح الرمز الاستجابي السريع لقسيمتك بكاميراك',
    write_your_code: 'اكتب رمزك...',
    validate: 'تحقق',
    back_to_store: 'العودة إلى المتجر',
    scan_qr: 'امسح رمز الاستجابة السريعة',
    scan_on_the_voucher: 'لبدء الاستخدام، امسح رمز الاستجابة السريعة للقسيمة',
    view_history: 'عرض السجل',
    voucher_history: 'سجل القسائم',
    voucher_history_description: 'يتيح لك هذا السجل تتبع التبادلات التي تم إجراؤها بدقة، مما يسهل متابعة وإدارة مكافآتك المتراكمة.',
    see_more: 'عرض المزيد',
    see_less: 'عرض أقل',

    //Faltantes
    upload_image: 'تحميل الصورة',
    uploaded_image: 'الصورة المحملة',
    photo: 'صورة',
    edit: 'تعديل',
    delete: 'حذف',
    enter_a_comment: 'أدخل تعليقاً',
    enter_a_value: 'أدخل قيمة',
    want_to_check_out: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    not_check_in_again: 'بمجرد التأكيد، لن تتمكن من تسجيل الدخول مرة أخرى حتى زيارتك القادمة.',

    //Alert
    alert: 'تنبيه',
    enter_characters: 'يجب إدخال 10 أحرف بعد البادئة',
    numerical_field: 'يجب أن يكون الحقل المُعدل رقمياً، بدون مسافات أو أحرف.',
    enter_date_of_birth: 'أدخل تاريخ ميلاد صالح بتنسيق YYYY-MM-DD.',
    session_expired: 'انتهت الجلسة',
    your_session_has_expired: 'لقد انتهت جلستك. يرجى المحاولة مرة أخرى.',
    error: 'خطأ',
    error_occurred: 'حدث خطأ أثناء محاولة تغيير كلمة المرور.',
    email_verification_code_incorrect: 'رمز التحقق من البريد الإلكتروني غير صحيح.',
    phone_verification_code_incorrect: 'رمز التحقق من رقم الهاتف غير صحيح.',
    no_checkin_found: 'لم يتم العثور على تسجيل الوصول.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
